import React from "react";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {Button, Grid, MenuItem, TextField} from "@mui/material";
import {FileInputEntry, IFileData} from "@shared/specialComponents/FileInputEntry.tsx";
import {Publish} from "@mui/icons-material";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {IArquivoOrcamento} from "@models/sistema/IArquivo.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {fullHeight, fullWidth} from "@models/helpers.ts";

export type OrcamentoAnexoType =
    'OrcamentoComprovantePagamento'
    | 'OrcamentoDadosPagamento'
    | 'NotaFiscal'
    | 'Orcamento'

export interface CreateAnexoOrcamentoProps {
    value?: Pick<ISolicitacaoOrcamento, 'id'>
    events?: {
        onCreate?: (value?: IArquivoOrcamento) => void;
    },
    tipo?: OrcamentoAnexoType
}

export const CreateAnexoOrcamentoComponent: React.FC<CreateAnexoOrcamentoProps> = (props) => {
    const {value} = props;
    const {Get} = useApi()
    const {createAlertFromResponse} = useAlert();
    const [tipo, setTipo] = React.useState<OrcamentoAnexoType | undefined>(props.tipo);
    const [file, setFile] = React.useState<IFileData | undefined>();
    const [isSending, setIsSending] = React.useState(false);

    const sendHandler = () => {
        if (!file) return;
        if (!value || !value.id) return;

        if (tipo != null) {
            setIsSending(true);
            Get(_OrcamentosEndpoints.CreateAnexoOrcamento({...file, orcamentoId: value.id, tipo})).then(x => {
                createAlertFromResponse(x);
                if (x.status === 'Success') {
                    setFile(undefined);
                    if (props.events && props.events.onCreate) props.events.onCreate(x.items)
                }
            }).finally(() => {
                setIsSending(false)
            })
        }
    }

    return (<Grid container>
        <Grid size={12}>
            <FileInputEntry files={file && [file]} onChange={(x) => {
                setFile(x && x[0] || undefined);
            }}/>
        </Grid>
        <Grid container size={12} justifyContent={'end'}>
            <Grid container size={{xs: 12, md: 8}}>
                <Grid size={6}>
                    <TextField value={tipo}
                               select
                               label={'Tipo de anexo'}
                               disabled={props.tipo != null}
                               onChange={(e) => {
                                   setTipo(e.target.value as OrcamentoAnexoType);
                               }}>
                        <MenuItem value={'OrcamentoComprovantePagamento'}>Comprovante de pagamento</MenuItem>
                        <MenuItem value={'OrcamentoDadosPagamento'}>Dados de pagamento</MenuItem>
                        <MenuItem value={'NotaFiscal'}>Nota fiscal</MenuItem>
                    </TextField>
                </Grid>
                <Grid size={6}>
                    <Button variant={'outlined'}
                            loading={isSending}
                            sx={{...fullHeight, ...fullWidth}}
                            color={'success'}
                            disabled={!file || tipo == null}
                            onClick={sendHandler}
                            endIcon={<Publish/>}>Incluir anexo</Button>
                </Grid>
            </Grid>
        </Grid>
    </Grid>)
}